export class SendItemModel {
    ItemId: string;   
    UserId: number; 

    constructor() {
        this.ItemId = ''; 
        this.UserId = 0; 

    }
  }
